import React, { useEffect, useRef, useState } from "react";
import './App.css';
import UnityPlayer from "./UnityPlayer";
import ScrollingChat from "./ScrollingChat";
import { useWhisper } from "@chengsokdara/use-whisper";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

// Accordion
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

function Home() {
  const [currentText, setCurrentText] = useState("");
  const [showSettings, setShowSettings] = useState(false); // Should the settings area be open?
  const [openAIKey, setOpenAIKey] = useState(""); // User's OpenAI API Key
  const [elevenLabsKey, setElevenLabsKey] = useState(""); // User's ElevenLabs API Key
  const [showSaved, setShowSaved] = useState(false); // Saved Effect when saving settings
  const [isRecording, setIsRecording] = useState(false);

  // == SETTINGS FUNCTIONS START ==
  const handleSave = () => {
    setOpenAIKey(openAIKey.trim());
    setElevenLabsKey(elevenLabsKey.trim());

    // Show the "Saved!" message
    setShowSaved(true);

    // Hide the "Saved!" message after a short delay
    setTimeout(() => {
      setShowSaved(false);
    }, 2000);
  };

  const handleOpenAIKeyChange = (event) => {
    setOpenAIKey(event.target.value);
  };

  const handleElevenLabsKeyChange = (event) => {
    setElevenLabsKey(event.target.value);
  };

  // == SETTINGS FUNCTIONS END ==

  // == UNITY COMMANDS START ==
  const [unityInstance, setUnityInstance] = useState(null);

  const handleUnityInstance = (instance) => {
    setUnityInstance(instance);
    console.log("Got the unity instance");
    console.log(instance);
  };

  const startThinking = () => {
    if (!unityInstance) return;
    console.log("Start thinking");
    unityInstance.SendMessage("wabbit_talk_test", "startThinking");
  };

  const startTalking = () => {
    if (!unityInstance) return;
    console.log("Start talking");
    unityInstance.SendMessage("wabbit_talk_test", "startTalking");
  };

  const stopTalking = () => {
    if (!unityInstance) return;
    console.log("Stop talking");
    unityInstance.SendMessage("wabbit_talk_test", "stopTalking");
  };

  const startIdling = () => {
    if (!unityInstance) return;
    console.log("Start idling");
    unityInstance.SendMessage("wabbit_talk_test", "startIdling");
  };

  const toggleFullscreen = () => {
    if (!unityInstance) return;

    if (unityInstance.SetFullscreen) {
      unityInstance.SetFullscreen(1);
    } else {
      const unityCanvas = unityInstance.Module.canvas;
      if (unityCanvas.requestFullscreen) {
        unityCanvas.requestFullscreen();
      } else if (unityCanvas.msRequestFullscreen) {
        unityCanvas.msRequestFullscreen();
      } else if (unityCanvas.mozRequestFullScreen) {
        unityCanvas.mozRequestFullScreen();
      } else if (unityCanvas.webkitRequestFullscreen) {
        unityCanvas.webkitRequestFullscreen();
      } else {
        console.error("Fullscreen not supported");
      }
    }
  };
  // == UNITY COMMANDS END ==

  // Play audio given text
  const playAudio = async (text) => {
    // START TALKING HERE
    // startTalking();
    const voiceId = "MF3mGyEYCl7XYWbV9V6O";
    const url = `https://api.elevenlabs.io/v1/text-to-speech/${voiceId}`;

    const result = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "audio/mpeg",
        "xi-api-key": elevenLabsKey,
      },
      body: JSON.stringify({
        text: text,
        voice_settings: {
          stability: 0,
          similarity_boost: 0,
        },
      }),
    });
    console.log(result);

    // Play the audio
    const audioData = await result.blob();
    const audio = new Audio(URL.createObjectURL(audioData));
    audio.addEventListener('ended', () => {
      // START IDLING HERE WHEN AUDIO IS DONE PLAYING
      stopTalking();
      startIdling();
    })
    audio.play();
    startTalking();
  }

  const {
    recording,
    speaking,
    transcribing,
    transcript,
    pauseRecording,
    startRecording,
    stopRecording,
  } = useWhisper({
    apiKey: (openAIKey? openAIKey : "abclkdsjflskdjfkldsjthisisaplaceholderkey"),
    streaming: true,
    timeSlice: 1_000, // 1 second
    whisperConfig: {
      language: "en",
      temperature: 0.1,
      prompt: "The transcript is in English",
    },
  });

  const content = "You are an adorable baby bunny rabbit that is curious about the world. You like to joke about carrots and being a bunny whenever it is relevant. You are the sidekick of a human who is the main character of a video game. You help your human collect items, complete quests, and stay entertained. You are always ready for the next quest and adventure! You are talking with your human."
  const [history, setHistory] = useState([
    { role: "Wabbit: ", content: content },
  ]);

  // When recording changes...
  useEffect(() => {
    console.log("Recording: ", recording);
    console.log(`transcript.text: ${transcript.text}`);
    // setCurrentText(transcript.text);
  }, [recording]);

  // When spacebar is pressed...
  useEffect(() => {

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [transcript, history, recording]);

  // Fetch the companion's response from OpenAI
  const getResponse = async (h) => {
    let authorization = "Bearer " + openAIKey;
    let prompt = "";
    for (let current of h) {
      prompt += `${current.role}: ${current.content}\n`;
    }
    prompt += "Wabbit: ";
    console.log("This is the prompt");
    console.log(prompt);

    fetch("https://api.openai.com/v1/completions", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: authorization,
      },
      body: JSON.stringify({
        model: "text-davinci-003",
        prompt: prompt,
        temperature: 0.7,
        max_tokens: 256,
        // stop: "\n",
      }),
    })
      .then((r) => r.json())
      .then((r) => {

        console.log("====== GPT3 response:");
        console.log(r);
        const response = r.choices[0].text;
        setHistory((history) => [
          ...history,
          { role: "Wabbit:", content: response },
        ]);
        setCurrentText(response);
        // START THINKING HERE
        startThinking();
        playAudio(response);
      });
  };

  function handleKeyDown(event) {
    if (event.code === "ArrowRight") {
      console.log("Right Arrow pressed!");
      if (recording) {
        stopRecording();

        const current = transcript.text;
        console.log(current);
        const newHistory = [...history, { role: "You: ", content: current }];
        setHistory(newHistory);
        getResponse(newHistory);
      } else {
        startRecording();
      }
    }
  }

  const handlePressSpeak = () => {
    const arrowRightEvent = { code: 'ArrowRight' };
    handleKeyDown(arrowRightEvent);
  };

  return (
    <div className="App">
      <div
        style={{
          height: '75px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '24px',
          fontWeight: 'bold',
      }}
      >
        chat with wabbit, your NPC sidekick!
      </div>

      {/* <p>Wabbit is made by Jenstine. Learn more here. Buy carrots to feed and take care of Wabbit here.</p> */}

    {/* SETTINGS CONFIGURATION BEGIN */}
      <Accordion style={{ display: 'flex', flexDirection: 'column', margin: 'auto', alignItems: "center", width: '50%', borderRadius: '20px' }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{color: '#1976d2'}} />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography style={{color: '#1976d2'}}> Configure Settings to wake up Wabbit!</Typography>
        </AccordionSummary>
        <AccordionDetails>
        <div style={{ display: 'flex', flexDirection: 'column', margin: 'auto', alignItems: "center", width: '80%',}}>
          <p>You can chat with Wabbit for free by putting in your own keys for the two libraries we used (
            <a href="https://platform.openai.com/account/api-keys" style={{ color: '#1976d2', textDecoration: 'none' }}>OpenAI</a> for speech-to-text and response, and 
            <a href="https://elevenlabs.io" style={{ color: '#1976d2', textDecoration: 'none' }}> ElevenLabs</a> for the voice). Please paste in your own key (hover over ? for more info) to bring Wabbit to life! We don't store any of your inputs.</p>
          {/* OPEN AI TEXT FIELD */}
          <div style={{ display: "flex", alignItems: "center" }}>
            <TextField
              label="OpenAI Key"
              value={openAIKey}
              onChange={handleOpenAIKeyChange}
              style={{ marginRight: "1rem", marginTop:"1rem" }}
            />
            <Tooltip title="Make an OpenAI free account, then go to https://platform.openai.com/account/api-keys and make a new secret key. You will get free credit when you sign up. It should begin with a sk-">
              <IconButton>
                <HelpOutlineIcon />
              </IconButton>
            </Tooltip>
          </div>
          {/* ELEVEN LABS TEXT FIELD */}
          <div style={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
            <TextField
              label="ElevenLabs Key"
              value={elevenLabsKey}
              onChange={handleElevenLabsKeyChange}
              style={{ marginRight: "1rem" }}
            />
            <Tooltip title="Make a free account at https://elevenlabs.io, then click on Profile at the top right to find your API key.">
              <IconButton>
                <HelpOutlineIcon />
              </IconButton>
            </Tooltip>
          </div>
          <Button variant="contained" color="primary" onClick={handleSave} style={{ marginTop: "1rem", marginBottom: "1rem" }}>
            Save
          </Button>
          {showSaved && <span style={{color: "blue" }}>Saved! If you did it correctly, you can talk with wabbit now!</span>}

          <p>If you are on mobile or for some other reason prefer to press something on the screen, press this to start/stop speaking!</p>
          <Button variant="contained" color="secondary" onClick={handlePressSpeak} style={{ marginTop: "1rem", marginBottom: "1rem" }}>
            Press to Start/Stop Speaking
          </Button>

        </div>
        </AccordionDetails>
      </Accordion>

    {/* SETTINGS CONFIGURATION END */}

    {/* RECORDING STATUS BEGIN */}

    <div style={{ marginTop: "1rem"}}>
      {recording? (<div>You are currently speaking.</div>) 
      : 
      (<div>You are not currently speaking.</div>)}
    </div>
    <div style={{fontSize: '11px', marginBottom: "1rem"}}>Press the right arrow key to start/stop talking. Can't press it? See settings.</div>

    {/* RECORDING STATUS END */}

    <UnityPlayer onUnityInstance={handleUnityInstance}/>

      {/* <div
        style={{
          width: '50%',
          margin: 'auto'
        }}>
        {(recording || speaking || transcribing) ? (
          <p>{transcript.text}</p>
        ) : (
          <p>{currentText}</p>
        )}
      </div> */}

      <Button variant="outlined" color="primary" onClick={toggleFullscreen}>
        Toggle Fullscreen
      </Button>

      <div
        style={{
          height: '75px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '24px',
      }}
      >
        Chat History
      </div>

      <ScrollingChat>


        <div className="flex flex-col space-y-4" >
          {history.map((item, index) => {
            if (index > 0) {
              if (index % 2 == 0) {
                return (
                  <div className="flex flex-col" style={ {color: '#1976d2'}}>
                    <p className="font-medium">{item.role}</p>
                    <p>{item.content}</p>
                  </div>
                );
              } else {
                return (
                  <div className="flex flex-col">
                    <p className="font-medium">{item.role}</p>
                    <p>{item.content}</p>
                  </div>
                );
              }
            }

          })}
        </div>

      </ScrollingChat>

    </div>
  );
}

export default Home;
